import { render, staticRenderFns } from "./AnnouncementTime.vue?vue&type=template&id=515058f1"
import script from "./AnnouncementTime.vue?vue&type=script&lang=js"
export * from "./AnnouncementTime.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementTime.vue?vue&type=style&index=0&id=515058f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports